exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-content[data-v-21d34fdc] .ant-modal-header {\n  border-bottom: none;\n}\n.modal-content[data-v-21d34fdc] .ant-modal-body {\n  overflow-y: auto;\n  height: 400px;\n  padding: 0 !important;\n  margin: 0 24px 10px;\n}\n.modal-content[data-v-21d34fdc] .ant-upload {\n  height: 149px;\n}\n.modal-body[data-v-21d34fdc] {\n  font-size: 16px;\n  font-weight: bold;\n  padding-bottom: 20px;\n}\n", ""]);

// exports
